import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { ChatStateService } from '../../shared/services/chat-state.service';

import { MediaAudioComponent } from './media-type/media-audio/media-audio.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { SvgIconComponent } from '../../shared/components/svg-icon/svg-icon.component';
import { VideoComponent } from 'app/shared/components/video/video.component';
import { ImageComponent } from 'app/shared/components/image/image.component';

import { ICreatorContent } from '../../interfaces/creator.interfaces';
import { IButtonConfig } from '../../shared/interfaces/button.interfaces';
import { ISvgConfig } from '../../shared/interfaces/svg.interfaces';

import { EButtonSizes, EButtonTypes } from '../../shared/enums/button.enums';
import { ESvgTypes } from '../../shared/enums/svg.enums';
import { ECreatorVideoTypes, ECreatorMediaTypes } from '../../enums/creator.enums';
import { EImageUsage } from '../../shared/enums/image-usage.enums';

@Component({
  selector: 'stxt-creator-media-card',
  standalone: true,
  imports: [
    MediaAudioComponent,
    CommonModule,
    ButtonComponent,
    SvgIconComponent,
    VideoComponent,
    ImageComponent
  ],
  templateUrl: './creator-media-card.component.html',
  styleUrl: './creator-media-card.component.scss'
})
export class CreatorMediaCardComponent {
  @Input() media: ICreatorContent;
  @Input() userId: string;
  @Input() creatorId: string;

  chatButtonConfig: IButtonConfig = {
    fill: EButtonTypes.SecondaryDark,
    text: 'Chat Now',
    buttonSize: EButtonSizes.Small
  };

  chatIcon: ISvgConfig = {
    name: 'conversation',
    fill: ESvgTypes.None
  };

  protected readonly ECreatorVideoTypes = ECreatorVideoTypes;
  protected readonly ECreatorMediaTypes = ECreatorMediaTypes;
  protected readonly EImageUsage = EImageUsage;

  constructor(
    public router: Router,
    private readonly chatStateService: ChatStateService
  ) {}

  openChat(): void {
    this.chatStateService.setPendingCreatorId(this.creatorId);
    this.router.navigateByUrl(`chat`);
  }
}
